<article class="app_cardItem__container">

  <section class="app_cardItem__body">
    <div>
      <div class="app_cardItem__body_title">
        <app-fiel-title label="Lote N°: "></app-fiel-title>
        <span>{{ card.numeroLote }}</span>
      </div>
      <div class="padding-top_10">
        <app-fiel-title label="CUIT: "></app-fiel-title>
        <label>{{ card.cuit }}</label>
      </div>
      <div class="padding-top_10">
        <app-fiel-title label="Estado: "></app-fiel-title>
        <span [ngClass]="estado == 'enviado' ? 'app_cardItem__body_vigencia green' : 'app_cardItem__body_vigencia yellow'">
          {{ estado | titlecase }}
        </span>
      </div>
    </div>
    <div>
      <div class="padding-top_36">
        <app-fiel-title label="Establecimiento: "></app-fiel-title>
        <span>{{ card.establecimiento }}</span>
      </div>
      <div class="padding-top_10">
        <app-fiel-title label="Empresa: "></app-fiel-title>
        <span>{{ card.empresa }}</span>
      </div>
    </div>
    <div>
      <div class="padding-top_36">
        <app-fiel-title label="Fecha: "></app-fiel-title>
        <span>{{ fecha | date: 'dd/MM/yyyy' }}</span>
      </div>
    </div>
    <div style="display: flex; flex-wrap: wrap;">
      <div class="padding-top_36 p-col-6">
        <app-fiel-title label="Fecha de inicio:" required="true"></app-fiel-title>
        <p-calendar [(ngModel)]="fechaInicio" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy" id="fechaInicio" inputId="fechaInicio" name="fechaInicio"
            [disabled]="estado == 'enviado'">
        </p-calendar>
        <app-invalid-from-message *ngIf="submitted && fechaInicio == null && estado != 'enviado'"></app-invalid-from-message>
      </div>
      <div class="padding-top_36 p-col-6">
        <app-fiel-title label="Fecha de fin:" required="true"></app-fiel-title>
        <p-calendar [(ngModel)]="fechaFin" [showIcon]="true" dataType="date" dateFormat="dd/mm/yy"
            placeholder="dd/mm/yyyy" id="fechaFin" inputId="fechaFin" name="fechaFin"
            [disabled]="estado == 'enviado'" [minDate]="fechaInicio">
        </p-calendar>
        <app-invalid-from-message *ngIf="submitted && fechaFin == null && estado != 'enviado'"></app-invalid-from-message>
      </div>
      <app-invalid-from-message *ngIf="submitted && invalidDates" message="La fecha fin no puede ser menor a la fecha inicio"></app-invalid-from-message>
    </div>
    <div class="padding-icon">
      <i class="icon icon_24x_pencil fs_20 button-app cursor_pointer"
          pTooltip=""
          p-tooltip-text
          (click)="seeFormAgenda(card)">
      </i>
    </div>
  </section>
</article>
